import React from 'react';
const availableRoles = ['Администратор', 'Сотрудник'];

export default ({ value }) => (value !== null && !isNaN(value) ? <div>{availableRoles[+value]}</div> : '-');
